import { type ComponentProps } from 'react';
import styled from 'styled-components';
import { Button, List, Thumbnail, token } from '@bynder/design-system';

export const FakeAssetOption = styled.div`
    padding: 8px 16px;
    color: ${token.gray600};
`;

export const AssetThumbnail = styled(Thumbnail)<ComponentProps<typeof Thumbnail>>`
    min-width: 40px;
`;

export const AssetButton = styled(List.Item)`
    width: ${(props) => (props.subtext ? 'calc(100% - 50px)' : 'calc(100% + 12px)')};
`;

export const RemoveButton = styled(Button)`
    min-width: 50px;
`;
